import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type MTCButtonSize = 'lg' | 'md' | 'sm' | 'xs' | 'icon';
export type MTCButtonVariant =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'icon'
  | 'basic'
  | 'errorIcon'
  | 'iconContainer'
  | 'icon-raised'
  | 'icon-stroked';

type MTCButtonType = 'button' | 'submit' | 'reset';

export const MTCButtonVariantClass: Record<MTCButtonVariant, string> = {
  primary: 'mtc-btn-primary',
  secondary: 'mtc-btn-secondary',
  basic: 'mtc-btn-basic',
  icon: 'mtc-icon-btn',
  iconContainer: 'mtc-icon-container',
  error: 'mtc-btn-error',
  errorIcon: 'mtc-danger-icon-btn',
  'icon-raised': 'mtc-icon-btn mtc-icon-btn-raised',
  'icon-stroked': 'mtc-icon-btn mtc-icon-btn-stroked',
};

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mtc-button',
  imports: [],
  templateUrl: './mtc-button.component.html',
  styleUrl: './mtc-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class MTCButtonComponent {
  id = input<string>('');
  type = input<MTCButtonType>('button');
  size = input<MTCButtonSize>('md');
  useShadow = input<boolean>(false);
  variant = input<MTCButtonVariant>('primary');
  textAlign = input<'left' | 'center' | 'right'>('center');
  disabled = input(false, {
    transform: (value: boolean | string) => (typeof value === 'string' ? value === '' : value),
  });

  private btnVariantClass = computed(() => {
    const variant = this.variant();
    return MTCButtonVariantClass[variant];
  });

  private btnSizeClass = computed(() => {
    const size = this.size();
    const sizeClasses = {
      lg: 'mtc-btn-lg',
      md: 'mtc-btn-md',
      sm: 'mtc-btn-sm',
      xs: 'mtc-btn-xs',
      icon: 'mtc-btn-icon-size',
    };

    return sizeClasses[size];
  });

  protected btnClasses = computed(() => {
    return `mtc-btn text-body-medium ${this.btnVariantClass()} ${this.btnSizeClass()}`;
  });
}
